import { UBXColor } from '../color/color.enum';

export class UBXSnack {
    type: UBXColor;
    position: UBXSnackPosition;
    message: string;
    timer: number;
}
export enum UBXSnackPosition {
    Top = 0,
    Bottom = 1,
}
